import { TkRadioProps } from "../../../type/componentsType/TkRadio";
import {
  Radio,
  RadioProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import "./_style.scss";

/**
 * ラジオボタン
 * TkRadioコンポーネントは、MUIのRadioコンポーネントを拡張したものです。
 * @param {TkRadioProps} props - TkRadioコンポーネントのプロパティ
 * @param {string} [props.size="medium"] - TkRadioコンポーネントのsizeプロパティ
 * @param {function} [props.onChange="function"] - ラジオボタンを制御するイベント
   @param {string} [props.value=""] - ラジオボタンを制御するために必要な値
 * @returns TkRadio ラジオボタン
 */
export const TkRadio: React.FC<TkRadioProps & RadioProps> = (props) => {
  const {
    size = "medium",
    onChange,
    onClick,
    errorMessage,
    label,
    ...rest
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(event);
  };

  return (
    <FormControl>
      <FormControlLabel
        control={
          <Radio
            data-testid="tkRadio"
            size={size}
            onChange={handleChange}
            onClick={handleClick}
            {...rest}
          />
        }
        label={label}
      />
      {!!errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default TkRadio;
